import { nextTick as q, defineComponent as be, getCurrentInstance as ve, reactive as _e, ref as k, computed as x, watch as E, onMounted as ge, onUnmounted as Ke, resolveDirective as xe, createElementBlock as n, openBlock as i, normalizeStyle as B, normalizeClass as f, withDirectives as W, createCommentVNode as p, createElementVNode as u, vModelText as we, vShow as N, renderSlot as r, toDisplayString as b, createVNode as h, createBlock as w, withCtx as I, withModifiers as v, Teleport as Se, withKeys as $, Fragment as ie, renderList as ae } from "vue";
import _ from "./SvgRender.js";
import ne from "./SearchInput.js";
import re from "./LoadMoreWrapper.js";
import { _ as O } from "./Tooltip.vue_vue_type_style_index_0_lang-BO7XY0kq.js";
import { d as ke } from "./debounce-BJrVv5jG.js";
import { p as Ie, s as $e, b as Le } from "./baseMixins-HJffeBsS.js";
import { a as Te } from "./auto-position-DMW8NimX.js";
import { o as Ce } from "./index-DA7LeYY4.js";
import z from "./OverflowTooltip.js";
import Ve from "./Chip.js";
import { _ as Me } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const He = {
  mounted(d, g) {
    q(() => {
    }), Pe(d, (S) => {
      S && Ae(d, g);
    });
  },
  unmounted(d) {
    d._observeFn && d._observeFn.disconnect();
  }
};
function Ae(d, g) {
  g.value && window.requestAnimationFrame(() => {
    setTimeout(() => {
      d.focus();
    }, 200);
  });
}
function Pe(d, g) {
  const S = {
    root: document
  };
  d._observeFn = new IntersectionObserver((C, e) => {
    C.forEach((l) => {
      g(l.intersectionRatio > 0);
    });
  }, S), d._observeFn.observe(d);
}
const Ee = {
  key: 0,
  class: "arbo-select__label"
}, Be = { class: "arbo-select__label--text" }, We = { class: "arbo-select__display--text flex items-center w-full" }, De = {
  key: 0,
  class: "arbo-select__item--prefix-icon flex"
}, Re = {
  key: 0,
  class: "arbo-select__display--value"
}, Ue = {
  key: 1,
  class: "arbo-select__display--value"
}, Fe = {
  key: 1,
  class: "select-status"
}, Ne = {
  key: 1,
  class: "arbo-select__item--suffix-icon flex"
}, Oe = ["onKeydown"], ze = {
  key: 0,
  class: "arbo-select__filtered"
}, qe = ["onClick", "onMouseover"], je = {
  key: 0,
  class: "arbo-select__item--prefix-icon flex"
}, Xe = { key: 0 }, Ye = {
  key: 1,
  class: "arbo-select__item--label"
}, Ge = {
  key: 1,
  style: { display: "flex", "align-items": "center" }
}, Je = {
  key: 1,
  class: "arbo-select__item--label font-bold"
}, Qe = { class: "arbo-select__item--template-name" }, Ze = {
  key: 0,
  class: "arbo-select__item--suffix-icon flex"
}, et = { class: "arbo-select__empty" }, tt = { class: "arbo-select__empty--text arbo-select__item disable" }, lt = ["onKeydown"], st = {
  key: 0,
  class: "arbo-select__filtered"
}, ot = ["onClick", "onMouseover"], it = {
  key: 0,
  class: "arbo-select__item--prefix-icon flex"
}, at = {
  key: 1,
  class: "arbo-select__item--label"
}, nt = {
  key: 0,
  class: "arbo-select__item--suffix-icon flex"
}, rt = { class: "arbo-select__empty" }, ct = { class: "arbo-select__empty--text arbo-select__item disable" }, dt = /* @__PURE__ */ be({
  __name: "Select",
  props: {
    ...Le,
    ...$e,
    ...Ie,
    searchPlaceholder: {
      type: String,
      default: "Type to search"
    },
    isSearchAtBottom: {
      type: Boolean,
      default: !1
    },
    useAbsolutePosition: {
      type: Boolean,
      default: !1
    },
    useInTableMode: {
      type: Boolean,
      default: !1
    },
    showNavIcon: {
      type: Boolean,
      default: !0
    },
    itemHeight: {
      type: Number,
      default: 36
    },
    prependHeight: {
      type: Number,
      default: 0
    },
    wrapperListClass: {
      type: String,
      default: ""
    },
    morpheme: {
      type: Object,
      required: !1,
      default: () => ({ type: "none", value: null })
    },
    customDropdownWidth: {
      type: Number,
      default: 200
    },
    extraRemainingHeight: {
      type: Number,
      default: 0
    },
    itemMaxWidth: {
      type: String,
      default: "180"
    },
    itemHighlightedWidth: {
      type: String,
      default: "130"
    },
    isEnableMaxTooltip: {
      type: Boolean,
      default: !1
    },
    customStatusSelect: {
      type: Boolean,
      default: !1
    },
    templateKey: {
      type: String,
      default: "template_name"
    },
    enableLimitTooltip: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "clicked-item",
    "input",
    "update:ids",
    "ids",
    "update:modelValue",
    "update-value",
    "update:rawValue",
    "load-more",
    "search",
    "shown",
    "hidden"
  ],
  setup(d, { expose: g, emit: S }) {
    const C = ve();
    if (C) {
      const t = C.appContext.app;
      t.directive("auto-position") || t.directive("auto-position", Te), t.directive("auto-focus") || t.directive("auto-focus", He);
    }
    const e = d, l = _e({
      selected: [],
      show: !1,
      searchText: "",
      dropdownPosition: "",
      highlightedIndex: -1
    }), c = S, V = k(null), M = k(null), j = k(null), ce = k(null), H = k(null), de = k(!1), ue = {
      content: "Xmark",
      tooltip: ""
    };
    function K() {
      e.disable || !e.enableUpdate || (l.show = !1);
    }
    function X(t) {
      return e.enableLimitTooltip && e.selectLimit !== -1 && l.selected.length >= e.selectLimit && !U.value.includes(t[e.valueKey]);
    }
    x(() => e.useAbsolutePosition ? { top: 4, left: 0, right: 0, bottom: 36 } : { top: 4, left: -16, right: -16, bottom: 4 });
    function pe() {
      e.disable || !e.enableUpdate || (l.show = !0);
    }
    function D() {
      e.disable || !e.enableUpdate || (l.show = !l.show);
    }
    function R(t) {
      e.disable || !e.enableUpdate || t.disable || (c("clicked-item", t), fe(t));
    }
    function Y() {
      F(), e.selectLimit === 1 && K();
    }
    function fe(t) {
      const s = l.selected.filter((o) => o[e.valueKey] === t[e.valueKey]);
      let a = [...l.selected];
      if (s.length) {
        if (e.selectLimit === 1 && e.disableUnSelectSingleMode) {
          K();
          return;
        }
        a = a.filter((o) => o[e.valueKey] !== t[e.valueKey]), G(a);
      } else
        e.selectLimit === 1 ? (a.shift(), a.push(t), K()) : (e.selectLimit === -1 || e.selectLimit > a.length) && a.push(t), G(a), l.selected.length === 0 && e.useInTableMode && K();
    }
    function G(t) {
      c("update:rawValue", t);
      const s = t.map((o) => o[e.valueKey]);
      let a = null;
      s && s.length ? (e.selectLimit === 1 ? a = s[0] : a = s, c("update:modelValue", a), c("update-value", a)) : (e.selectLimit === 1 ? a = null : a = [], c("update:modelValue", a), c("update-value", a));
    }
    function A(t) {
      t && (e.selectLimit === 1 ? (l.selected = [], l.selected = [t], K()) : (e.selectLimit === -1 || e.selectLimit >= t.length) && (Array.isArray(t) ? l.selected = [...t] : l.selected = [t]));
    }
    E(
      () => e.modelValue,
      (t) => {
        if (e.selectLimit === 1)
          if (t) {
            const s = e.options.find((a) => t === a[e.valueKey]);
            A(s);
          } else
            l.selected = [];
        else {
          const s = e.options.filter((a) => t.includes(a[e.valueKey]));
          A(s);
        }
      }
    );
    const U = x(() => {
      const t = l.selected.map((s) => s[e.valueKey]);
      if (t && t.length) {
        c("update:ids", t), c("ids", t);
        let s = null;
        e.selectLimit === 1 ? s = t[0] : s = t, c("update-value", s);
      }
      return t;
    }), L = x(() => {
      let t = e.placeholder;
      const s = l.selected.length;
      switch (s > 1 ? t = `${s} selected` : s === 1 && !e.customStatusSelect ? t = l.selected[0][e.labelKey] : s === 1 && e.customStatusSelect && (t = `${s} selected`), e.morpheme.type) {
        case "suffix":
          t = `${e.morpheme.value} ${t}`;
          break;
        case "prefix":
          t = `${t} ${e.morpheme.value}`;
          break;
      }
      return t;
    });
    E(
      () => l.selected,
      (t) => {
        c("input", t);
      }
    ), E(
      () => l.show,
      (t) => {
        t ? (c("shown"), q(() => {
          oe();
        })) : c("hidden");
      }
    );
    const he = ke((t) => {
      c("search", t);
    }, 500);
    E(
      () => l.searchText,
      (t) => {
        he(t);
      }
    );
    const y = x(() => !e.allowSearch || !l.searchText || e.isUsingSearchServer ? e.options : e.options.filter(
      (t) => t[e.labelKey]?.trim()?.toLowerCase().indexOf(l.searchText?.trim()?.toLowerCase()) >= 0
    ) || []), J = x(() => l.selected.length);
    function ye() {
      l.searchText = "";
    }
    function F() {
      e.selectLimit === 1 ? (c("update:modelValue", null), c("update-value", null)) : (c("update:modelValue", []), c("update-value", []));
    }
    function Q() {
      c("load-more");
    }
    const P = x(() => ({
      "--select__list-height": `${32 + e.itemHeight * (y.value.length > 5 ? 5 : y.value.length) + e.prependHeight - e.extraRemainingHeight}px`,
      "--select__list-inner-height": e.extraRemainingHeight ? `${e.itemHeight * (y.value.length > 5 ? 5 : y.value.length)}px` : "calc(100% - 32px)",
      "--select__list-item-max-width": e.isEnableMaxTooltip ? `${e.itemMaxWidth}px` : "",
      "--select__list-item-highlighted-width": e.isEnableMaxTooltip ? `${me.value}px` : "",
      "--dropdown--width": `${e.customDropdownWidth}px`
    })), me = x(() => {
      let t = parseInt(e.itemHighlightedWidth);
      return e.selectLimit === 1 ? t + 32 : t;
    }), Z = () => {
      l.highlightedIndex > 0 && (l.highlightedIndex--, le());
    }, ee = () => {
      l.highlightedIndex < y.value.length - 1 && (l.highlightedIndex++, le());
    }, te = () => {
      if (l.highlightedIndex !== -1) {
        const t = y.value[l.highlightedIndex];
        R(t);
      }
    }, le = () => {
      const t = M.value;
      if (t) {
        const s = l.highlightedIndex * e.itemHeight + e.prependHeight, a = t.clientHeight;
        s < t.scrollTop ? t.scrollTop = s : s + e.itemHeight > t.scrollTop + a && (t.scrollTop = s - a + e.itemHeight);
      }
    };
    Ce(M, K, {
      ignore: [j, V]
    });
    const se = () => {
      l.show = !1;
    };
    ge(() => {
      q(() => {
        if (H.value && (de.value = !0), e.modelValue)
          if (e.selectLimit === 1) {
            const t = e.options.find((s) => e.modelValue === s[e.valueKey]);
            A(t);
          } else
            e.options.filter((s) => e.modelValue.includes(s[e.valueKey])).forEach((s) => A(s));
      }), window.addEventListener("resize", () => {
        setTimeout(() => {
          se();
        }, 250);
      });
    }), Ke(() => {
      window.removeEventListener("resize", se);
    });
    const oe = () => {
      V.value?.focusInput();
    };
    return g({
      removeSearch: ye,
      focustSearchInput: oe,
      hideList: K,
      showList: pe,
      showLimitTooltip: X
    }), (t, s) => {
      const a = xe("auto-position");
      return i(), n("div", {
        class: f(["arbo-select flex flex-col items-start", [{ "empty-select": !l.selected.length }]]),
        style: B(t.sharedStyles),
        ref_key: "selectComponentRef",
        ref: ce
      }, [
        W(u("input", {
          "onUpdate:modelValue": s[0] || (s[0] = (o) => l.selected = o)
        }, null, 512), [
          [we, l.selected],
          [N, !1]
        ]),
        e.label ? (i(), n("div", Ee, [
          r(t.$slots, "label", {
            label: e.label
          }, () => [
            u("div", Be, b(e.label), 1)
          ], !0)
        ])) : p("", !0),
        W((i(), n("div", {
          class: "arbo-select__wrapper w-full",
          style: B(P.value)
        }, [
          h(O, {
            class: "arbo-select__display-tooltip",
            content: e.tooltipDisplay,
            delay: [300, 0],
            "hide-on-click": !0,
            placement: e.tooltipDisplayPlacement
          }, {
            default: I(() => [
              u("div", {
                class: f(["arbo-select__display flex items-center", [{ border: e.hasBorder }, { "has-border-bottom": e.hasBottomLine }, e.isDark ? "dark" : "light", { disable: e.disable }]]),
                ref_key: "selectDisplay",
                ref: j,
                onClick: s[1] || (s[1] = (o) => D())
              }, [
                r(t.$slots, "select-display", {
                  toggleShowlist: D,
                  disable: e.disable
                }, () => [
                  r(t.$slots, "prefix-icon", { totalSelected: J.value }, void 0, !0),
                  u("div", We, [
                    e.customStatusSelect ? p("", !0) : r(t.$slots, "prefix-item", {
                      key: 0,
                      displayValue: L.value,
                      selectingItem: l.selected.length === 1 ? l.selected[0] : null,
                      prefixIconKey: t.prefixIconKey
                    }, () => [
                      l.selected.length === 1 && e.prefixIconKey && l.selected[0][e.prefixIconKey] ? (i(), n("div", De, [
                        h(_, {
                          class: "arbo-select__item--icon",
                          url: l.selected[0][e.prefixIconKey]
                        }, null, 8, ["url"])
                      ])) : p("", !0)
                    ], !0),
                    r(t.$slots, "display-selecting", {
                      displayValue: L.value,
                      selectingItem: l.selected.length === 1 ? l.selected[0] : null,
                      prefixIconKey: t.prefixIconKey
                    }, () => [
                      e.customStatusSelect ? (i(), n("div", Ue, [
                        l.selected.length > 0 ? (i(), w(Ve, {
                          key: 0,
                          class: "select-status-chip",
                          label: L.value,
                          suffixContent: l.show ? ue : {},
                          disableHover: !0,
                          onSuffixClicked: F
                        }, null, 8, ["label", "suffixContent"])) : (i(), n("div", Fe, b(L.value), 1))
                      ])) : (i(), n("div", Re, b(L.value), 1))
                    ], !0),
                    l.selected.length === 1 && e.suffixIconKey && l.selected[0][e.suffixIconKey] ? (i(), n("div", Ne, [
                      h(_, {
                        class: "arbo-select__item--icon",
                        url: l.selected[0][e.suffixIconKey]
                      }, null, 8, ["url"])
                    ])) : p("", !0),
                    e.isClearable && J.value ? (i(), n("div", {
                      key: 2,
                      class: "arbo-select__clearable",
                      onClick: v(F, ["stop"])
                    }, [
                      h(O, {
                        class: "arbo-select__clearable--tooltip",
                        content: "Clear",
                        delay: [300, 0]
                      }, {
                        default: I(() => [
                          h(_, {
                            class: "arbo-select__search--remove",
                            url: e.clearIcon,
                            "class-icon": "arbo-input--icon"
                          }, null, 8, ["url"])
                        ]),
                        _: 1
                      })
                    ])) : p("", !0)
                  ]),
                  r(t.$slots, "suffix-icon", {}, () => [
                    e.showNavIcon ? (i(), n("div", {
                      key: 0,
                      class: f(["arbo-select__display--suffix-icon", [l.show ? "up" : "down", { "empty-select": !l.selected.length }]]),
                      onClick: v(D, ["stop", "prevent"])
                    }, [
                      h(_, {
                        name: e.navIcon
                      }, null, 8, ["name"])
                    ], 2)) : p("", !0)
                  ], !0)
                ], !0)
              ], 2)
            ]),
            _: 3
          }, 8, ["content", "placement"]),
          e.useAbsolutePosition ? (i(), w(Se, {
            key: 0,
            to: "body"
          }, [
            W(u("div", {
              class: f(["arbo-select__list-wrapper", [{ "absolute-body": e.useAbsolutePosition }, e.wrapperListClass]]),
              ref_key: "selectListWrapperRef",
              ref: H,
              onKeydown: [
                $(v(Z, ["prevent", "stop"]), ["up"]),
                $(v(ee, ["prevent", "stop"]), ["down"]),
                $(v(te, ["prevent", "stop"]), ["enter"])
              ]
            }, [
              u("div", {
                class: f(["arbo-select__list-inner", [{ reverse: e.isSearchAtBottom, "absolute-body": e.useAbsolutePosition }]]),
                style: B(P.value)
              }, [
                e.allowSearch ? (i(), w(ne, {
                  key: 0,
                  class: "arbo-select__search",
                  modelValue: l.searchText,
                  "onUpdate:modelValue": s[2] || (s[2] = (o) => l.searchText = o),
                  ref_key: "searchInput",
                  ref: V,
                  placeholder: e.searchPlaceholder,
                  "is-dark": !0,
                  "auto-focus": !0
                }, null, 8, ["modelValue", "placeholder"])) : p("", !0),
                u("div", {
                  class: f(["arbo-select__list", [{ "allow-search": e.allowSearch, "has-empty-section": !!e.emptyText }, l.dropdownPosition]]),
                  ref_key: "listSelectWrapper",
                  ref: M
                }, [
                  r(t.$slots, "prepend_list", { clearAllSelectedAndCloseList: Y }, void 0, !0),
                  r(t.$slots, "list", { options: y.value }, () => [
                    y.value.length ? (i(), n("div", ze, [
                      h(re, {
                        "is-enable": t.isEnableLoadMore,
                        onLoadMore: Q,
                        "loader-class": "mini"
                      }, {
                        default: I(() => [
                          (i(!0), n(ie, null, ae(y.value, (o, m) => (i(), n("div", {
                            class: f(["arbo-select__item", {
                              selected: U.value.includes(o[e.valueKey]),
                              disable: o.disable,
                              highlighted: m === l.highlightedIndex
                            }]),
                            key: m,
                            onClick: (T) => R(o),
                            onMouseover: (T) => l.highlightedIndex = m,
                            onMouseleave: s[3] || (s[3] = (T) => l.highlightedIndex = -1)
                          }, [
                            h(O, {
                              class: "flex",
                              content: X(o) ? "Limit reached. You can select up to 5 statuses." : "",
                              delay: [300, 0],
                              hideOnClick: !1,
                              style: { width: "100%", "align-items": "center" }
                            }, {
                              default: I(() => [
                                r(t.$slots, `option_${o[e.valueKey]}`, {
                                  item: o,
                                  valueKey: t.valueKey,
                                  labelKey: t.labelKey
                                }, () => [
                                  r(t.$slots, "prefix_item", {
                                    item: o,
                                    valueKey: t.valueKey,
                                    labelKey: t.labelKey,
                                    prefixIconKey: t.prefixIconKey
                                  }, () => [
                                    e.prefixIconKey && o[e.prefixIconKey] ? (i(), n("div", je, [
                                      h(_, {
                                        class: "arbo-select__item--icon",
                                        url: o[e.prefixIconKey]
                                      }, null, 8, ["url"])
                                    ])) : p("", !0)
                                  ], !0),
                                  e.customStatusSelect ? (i(), n("div", Ge, [
                                    d.isEnableMaxTooltip ? (i(), w(z, {
                                      key: 0,
                                      class: "arbo-select__item--label font-bold",
                                      title: o[t.labelKey],
                                      style: { width: "fit-content !important" }
                                    }, null, 8, ["title"])) : (i(), n("div", Je, b(o[t.labelKey]), 1)),
                                    s[6] || (s[6] = u("div", { class: "arbo-select__item--separator" }, "| ", -1)),
                                    u("div", Qe, b(o[d.templateKey]), 1)
                                  ])) : (i(), n("div", Xe, [
                                    d.isEnableMaxTooltip ? (i(), w(z, {
                                      key: 0,
                                      class: f(["arbo-select__item--label", { "is-max-height": m === l.highlightedIndex }]),
                                      title: o[t.labelKey],
                                      style: { width: "fit-content !important" }
                                    }, null, 8, ["class", "title"])) : (i(), n("div", Ye, b(o[t.labelKey]), 1))
                                  ])),
                                  r(t.$slots, "suffix_item", {
                                    item: o,
                                    valueKey: t.valueKey,
                                    labelKey: t.labelKey,
                                    prefixIconKey: t.suffixIconKey
                                  }, () => [
                                    e.suffixIconKey && o[e.suffixIconKey] ? (i(), n("div", Ze, [
                                      h(_, {
                                        class: "arbo-select__item--icon",
                                        url: o[e.suffixIconKey]
                                      }, null, 8, ["url"])
                                    ])) : p("", !0)
                                  ], !0)
                                ], !0)
                              ]),
                              _: 2
                            }, 1032, ["content"])
                          ], 42, qe))), 128))
                        ]),
                        _: 3
                      }, 8, ["is-enable"])
                    ])) : e.emptyText ? r(t.$slots, "empty_text", { key: 1 }, () => [
                      u("div", et, [
                        u("div", tt, b(e.emptyText), 1)
                      ])
                    ], !0) : p("", !0)
                  ], !0),
                  r(t.$slots, "append_list", {}, void 0, !0)
                ], 2)
              ], 6)
            ], 42, Oe), [
              [N, l.show && !e.disable]
            ])
          ])) : W((i(), n("div", {
            key: 1,
            class: f(["arbo-select__list-wrapper", [{ "absolute-body": e.useAbsolutePosition }, e.wrapperListClass]]),
            ref_key: "selectListWrapperRef",
            ref: H,
            onKeydown: [
              $(v(Z, ["prevent", "stop"]), ["up"]),
              $(v(ee, ["prevent", "stop"]), ["down"]),
              $(v(te, ["prevent", "stop"]), ["enter"])
            ]
          }, [
            u("div", {
              class: f(["arbo-select__list-inner", [{ reverse: e.isSearchAtBottom, "absolute-body": e.useAbsolutePosition }]]),
              style: B(P.value)
            }, [
              e.allowSearch ? (i(), w(ne, {
                key: 0,
                class: "arbo-select__search",
                modelValue: l.searchText,
                "onUpdate:modelValue": s[4] || (s[4] = (o) => l.searchText = o),
                ref_key: "searchInput",
                ref: V,
                placeholder: e.searchPlaceholder,
                "is-dark": !0,
                "auto-focus": !0
              }, null, 8, ["modelValue", "placeholder"])) : p("", !0),
              u("div", {
                class: f(["arbo-select__list", [{ "allow-search": e.allowSearch, "has-empty-section": !!e.emptyText }, l.dropdownPosition]]),
                ref_key: "listSelectWrapper",
                ref: M
              }, [
                r(t.$slots, "prepend_list", { clearAllSelectedAndCloseList: Y }, void 0, !0),
                r(t.$slots, "list", { options: y.value }, () => [
                  y.value.length ? (i(), n("div", st, [
                    h(re, {
                      "is-enable": t.isEnableLoadMore,
                      onLoadMore: Q,
                      "loader-class": "mini"
                    }, {
                      "loading-animation": I(() => [
                        r(t.$slots, "loading-animation", {}, void 0, !0)
                      ]),
                      default: I(() => [
                        (i(!0), n(ie, null, ae(y.value, (o, m) => (i(), n("div", {
                          class: f(["arbo-select__item", {
                            selected: U.value.includes(o[e.valueKey]),
                            disable: o.disable,
                            highlighted: m === l.highlightedIndex
                          }]),
                          key: m,
                          onClick: (T) => R(o),
                          onMouseover: (T) => l.highlightedIndex = m,
                          onMouseleave: s[5] || (s[5] = (T) => l.highlightedIndex = -1)
                        }, [
                          r(t.$slots, `option_${o[e.valueKey]}`, {
                            item: o,
                            valueKey: t.valueKey,
                            labelKey: t.labelKey
                          }, () => [
                            r(t.$slots, "prefix_item", {
                              item: o,
                              valueKey: t.valueKey,
                              labelKey: t.labelKey,
                              prefixIconKey: t.prefixIconKey
                            }, () => [
                              e.prefixIconKey && o[e.prefixIconKey] ? (i(), n("div", it, [
                                h(_, {
                                  class: "arbo-select__item--icon",
                                  url: o[e.prefixIconKey]
                                }, null, 8, ["url"])
                              ])) : p("", !0)
                            ], !0),
                            d.isEnableMaxTooltip ? (i(), w(z, {
                              key: 0,
                              class: f(["arbo-select__item--label", { "is-max-height": m === l.highlightedIndex }]),
                              title: o[t.labelKey],
                              style: { width: "fit-content !important" }
                            }, null, 8, ["class", "title"])) : (i(), n("div", at, b(o[t.labelKey]), 1)),
                            r(t.$slots, "suffix_item", {
                              item: o,
                              valueKey: t.valueKey,
                              labelKey: t.labelKey,
                              prefixIconKey: t.suffixIconKey
                            }, () => [
                              e.suffixIconKey && o[e.suffixIconKey] ? (i(), n("div", nt, [
                                h(_, {
                                  class: "arbo-select__item--icon",
                                  url: o[e.suffixIconKey]
                                }, null, 8, ["url"])
                              ])) : p("", !0)
                            ], !0)
                          ], !0)
                        ], 42, ot))), 128))
                      ]),
                      _: 3
                    }, 8, ["is-enable"])
                  ])) : e.emptyText ? r(t.$slots, "empty_text", { key: 1 }, () => [
                    u("div", rt, [
                      u("div", ct, b(e.emptyText), 1)
                    ])
                  ], !0) : p("", !0)
                ], !0),
                r(t.$slots, "append_list", {}, void 0, !0)
              ], 2)
            ], 6)
          ], 42, lt)), [
            [N, l.show && !e.disable]
          ])
        ], 4)), [
          [a, { listEl: H.value, sharedStyles: P.value, isEnable: e.useAbsolutePosition, isUseAbsolute: e.useAbsolutePosition, extraRemainingHeight: e.extraRemainingHeight, currentVisibleState: l.show }]
        ])
      ], 6);
    };
  }
}), wt = /* @__PURE__ */ Me(dt, [["__scopeId", "data-v-3f086376"]]);
export {
  wt as A,
  He as a
};
